import SSOView from './SSOView';

export default SSOView;
